// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_form__lZ6H3 {
  margin: 20px 0;
}
.user_form__lZ6H3 .user_formGroup__xpETX {
  margin-bottom: 12px;
  position: relative;
}
.user_form__lZ6H3 .user_eyeIcon__SKjob {
  cursor: pointer;
  background-color: red;
}
.user_form__lZ6H3 .user_signUpBtn__nQXCY,
.user_form__lZ6H3 .user_signInBtn__M2Uff,
.user_form__lZ6H3 .user_skipBtn__2sX9j {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 12px 0;
}
.user_form__lZ6H3 .user_signUpBtn__nQXCY .user_forgotPassword__LdEl2,
.user_form__lZ6H3 .user_signInBtn__M2Uff .user_forgotPassword__LdEl2,
.user_form__lZ6H3 .user_skipBtn__2sX9j .user_forgotPassword__LdEl2 {
  font: var(--body-font-two);
  color: var(--primary-color);
  cursor: pointer;
}
.user_form__lZ6H3 .user_signUpBtn__nQXCY button,
.user_form__lZ6H3 .user_signInBtn__M2Uff button,
.user_form__lZ6H3 .user_skipBtn__2sX9j button {
  min-width: 120px;
  min-height: 42px;
  text-transform: capitalize;
  box-shadow: unset;
}
.user_form__lZ6H3 .user_signUpBtn__nQXCY.user_signInBtn__M2Uff, .user_form__lZ6H3 .user_signUpBtn__nQXCY.user_skipBtn__2sX9j,
.user_form__lZ6H3 .user_signInBtn__M2Uff.user_signInBtn__M2Uff,
.user_form__lZ6H3 .user_signInBtn__M2Uff.user_skipBtn__2sX9j,
.user_form__lZ6H3 .user_skipBtn__2sX9j.user_signInBtn__M2Uff,
.user_form__lZ6H3 .user_skipBtn__2sX9j.user_skipBtn__2sX9j {
  justify-content: space-between;
}
.user_form__lZ6H3 .user_or__K49hG {
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
  margin: 20px 0;
  position: relative;
}
.user_form__lZ6H3 .user_or__K49hG p {
  font: var(--body-font-three);
  color: #8692a4;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-transform: capitalize;
  background-color: #faf4f2;
  padding: 0px 10px;
  text-align: center;
}
.user_form__lZ6H3 .user_socialLoginBtns__HvxcO {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;
}
.user_form__lZ6H3 .user_socialLoginBtns__HvxcO button {
  min-height: 36px;
  box-shadow: unset;
  text-transform: capitalize;
  font: var(--body-font-three);
  font-weight: 500;
}
.user_form__lZ6H3 .user_socialLoginBtns__HvxcO button img,
.user_form__lZ6H3 .user_socialLoginBtns__HvxcO button svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
}

.user_forgotPwSection__2Dt6v .user_formContainer__9k0CN .user_titleContainer__TyT4S {
  margin-bottom: 5px;
}

@media (max-width: 991px) {
  .user_form__lZ6H3 {
    margin: 15px 0;
  }
  .user_form__lZ6H3 .user_formGroup__xpETX {
    margin-bottom: 10px;
  }
  .user_form__lZ6H3 .user_signUpBtn__nQXCY,
  .user_form__lZ6H3 .user_signInBtn__M2Uff,
  .user_form__lZ6H3 .user_skipBtn__2sX9j {
    margin: 10px 0;
  }
  .user_form__lZ6H3 .user_signUpBtn__nQXCY button,
  .user_form__lZ6H3 .user_signInBtn__M2Uff button,
  .user_form__lZ6H3 .user_skipBtn__2sX9j button {
    min-width: 120px;
    min-height: 30px;
  }
  .user_form__lZ6H3 .user_or__K49hG {
    margin: 20px 0;
  }
  .user_form__lZ6H3 .user_or__K49hG p {
    font-size: 12px;
  }
  .user_form__lZ6H3 .user_socialLoginBtns__HvxcO {
    margin-top: 20px;
    gap: 10px;
  }
}
@media (max-width: 767px) {
  .user_form__lZ6H3 .user_signUpBtn__nQXCY button,
  .user_form__lZ6H3 .user_signInBtn__M2Uff button,
  .user_form__lZ6H3 .user_skipBtn__2sX9j button {
    min-height: 38px;
    min-width: unset;
  }
}
.user_uploadCircle__m9Fef {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  border: 2px solid #ddd;
  background-color: white;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-size: 0.9rem;
}

.user_cameraIcon__\\+LWjq {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: #85a9b8;
  color: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/onboardingCards/user/user.module.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;AACC;EACC,mBAAA;EACA,kBAAA;AACF;AAEC;EACC,eAAA;EACA,qBAAA;AAAF;AAGC;;;EAGC,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AADF;AAGE;;;EACC,0BAAA;EACA,2BAAA;EACA,eAAA;AACH;AAEE;;;EACC,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;AAEH;AACE;;;;;EAEC,8BAAA;AAIH;AAAC;EACC,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAEF;AAAE;EACC,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAEH;AAEC;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAAF;AAEE;EACC,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;AAAJ;;AAQE;EACC,kBAAA;AALH;;AAUA;EACC;IACC,cAAA;EAPA;EASA;IACC,mBAAA;EAPD;EAUA;;;IAGC,cAAA;EARD;EAUC;;;IACC,gBAAA;IACA,gBAAA;EANF;EAUA;IACC,cAAA;EARD;EAUC;IACC,eAAA;EARF;EAYA;IACC,gBAAA;IACA,SAAA;EAVD;AACF;AAcA;EAKG;;;IACC,gBAAA;IACA,gBAAA;EAdF;AACF;AAqBA;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAnBD;;AAsBA;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAnBD","sourcesContent":[".form {\r\n\tmargin: 20px 0;\r\n\r\n\t.formGroup {\r\n\t\tmargin-bottom: 12px;\r\n\t\tposition: relative;\r\n\t}\r\n\r\n\t.eyeIcon {\r\n\t\tcursor: pointer;\r\n\t\tbackground-color: red;\r\n\t}\r\n\r\n\t.signUpBtn,\r\n\t.signInBtn,\r\n\t.skipBtn {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: flex-end;\r\n\t\talign-items: center;\r\n\t\tmargin: 12px 0;\r\n\r\n\t\t.forgotPassword {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tcolor: var(--primary-color);\r\n\t\t\tcursor: pointer;\r\n\t\t}\r\n\r\n\t\tbutton {\r\n\t\t\tmin-width: 120px;\r\n\t\t\tmin-height: 42px;\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tbox-shadow: unset;\r\n\t\t}\r\n\r\n\t\t&.signInBtn,\r\n\t\t&.skipBtn {\r\n\t\t\tjustify-content: space-between;\r\n\t\t}\r\n\t}\r\n\r\n\t.or {\r\n\t\twidth: 100%;\r\n\t\theight: 1px;\r\n\t\tbackground-color: #e5e5e5;\r\n\t\tmargin: 20px 0;\r\n\t\tposition: relative;\r\n\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tcolor: #8692a4;\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 50%;\r\n\t\t\tleft: 50%;\r\n\t\t\ttransform: translate(-50%, -50%);\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tbackground-color: #faf4f2;\r\n\t\t\tpadding: 0px 10px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\t}\r\n\r\n\t.socialLoginBtns {\r\n\t\tmargin-top: 25px;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: center;\r\n\t\tgap: 15px;\r\n\r\n\t\tbutton {\r\n\t\t\tmin-height: 36px;\r\n\t\t\tbox-shadow: unset;\r\n\t\t\ttext-transform: capitalize;\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 500;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.forgotPwSection {\r\n\t.formContainer {\r\n\t\t.titleContainer {\r\n\t\t\tmargin-bottom: 5px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.form {\r\n\t\tmargin: 15px 0;\r\n\r\n\t\t.formGroup {\r\n\t\t\tmargin-bottom: 10px;\r\n\t\t}\r\n\r\n\t\t.signUpBtn,\r\n\t\t.signInBtn,\r\n\t\t.skipBtn {\r\n\t\t\tmargin: 10px 0;\r\n\r\n\t\t\tbutton {\r\n\t\t\t\tmin-width: 120px;\r\n\t\t\t\tmin-height: 30px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.or {\r\n\t\t\tmargin: 20px 0;\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont-size: 12px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.socialLoginBtns {\r\n\t\t\tmargin-top: 20px;\r\n\t\t\tgap: 10px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.form {\r\n\t\t.signUpBtn,\r\n\t\t.signInBtn,\r\n\t\t.skipBtn {\r\n\t\t\tbutton {\r\n\t\t\t\tmin-height: 38px;\r\n\t\t\t\tmin-width: unset;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n//\r\n\r\n.uploadCircle {\r\n\twidth: 140px;\r\n\theight: 140px;\r\n\tborder-radius: 50%;\r\n\tborder: 2px solid #ddd;\r\n\tbackground-color: white;\r\n\tcolor: #888;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\ttext-align: center;\r\n\tcursor: pointer;\r\n\tposition: relative;\r\n\tfont-size: 0.9rem;\r\n}\r\n\r\n.cameraIcon {\r\n\tposition: absolute;\r\n\tbottom: 8px;\r\n\tright: 8px;\r\n\tbackground-color: #85a9b8;\r\n\tcolor: white;\r\n\tborder-radius: 50%;\r\n\twidth: 32px;\r\n\theight: 32px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tfont-size: 1.1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `user_form__lZ6H3`,
	"formGroup": `user_formGroup__xpETX`,
	"eyeIcon": `user_eyeIcon__SKjob`,
	"signUpBtn": `user_signUpBtn__nQXCY`,
	"signInBtn": `user_signInBtn__M2Uff`,
	"skipBtn": `user_skipBtn__2sX9j`,
	"forgotPassword": `user_forgotPassword__LdEl2`,
	"or": `user_or__K49hG`,
	"socialLoginBtns": `user_socialLoginBtns__HvxcO`,
	"forgotPwSection": `user_forgotPwSection__2Dt6v`,
	"formContainer": `user_formContainer__9k0CN`,
	"titleContainer": `user_titleContainer__TyT4S`,
	"uploadCircle": `user_uploadCircle__m9Fef`,
	"cameraIcon": `user_cameraIcon__+LWjq`
};
export default ___CSS_LOADER_EXPORT___;
